<app-tariff
  [tariffs]="tariffs"
></app-tariff>
<app-contact-us></app-contact-us>
